"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OwnerContactSection = void 0;
var react_1 = __importDefault(require("react"));
/**
 * Quick-action contact strip. Renders a "Reach out" mailto button
 * when the canonical element has an owner email; falls back to a
 * read-only name when only a name is known. Hidden entirely when
 * the catalogue has no owner information yet.
 */
exports.OwnerContactSection = function (_a) {
    var _b, _c;
    var owner = _a.owner;
    if (!owner || (!owner.email && !owner.name))
        return null;
    var label = ((_b = owner.name) === null || _b === void 0 ? void 0 : _b.trim()) || owner.email;
    var subject = ("AI Hub follow-up: " + ((_c = owner.name) !== null && _c !== void 0 ? _c : '')).trim();
    return (react_1.default.createElement("section", { className: "ws-entity-popup-section", "data-section-id": "owner" },
        react_1.default.createElement("h4", { className: "ws-entity-popup-section-title" }, "Owner"),
        react_1.default.createElement("div", { className: "ws-entity-popup-chip-row", style: { alignItems: 'center', gap: 8 } },
            react_1.default.createElement("i", { className: "ms-Icon ms-Icon--Contact", "aria-hidden": "true", style: { color: '#6b7280' } }),
            react_1.default.createElement("span", { style: { fontWeight: 500 } }, label),
            owner.email ? (react_1.default.createElement("a", { href: "mailto:" + encodeURIComponent(owner.email) + "?subject=" + encodeURIComponent(subject), className: "ws-entity-popup-chip", style: {
                    textDecoration: 'none',
                    background: '#eff6ff',
                    color: '#1e40af',
                } },
                react_1.default.createElement("i", { className: "ms-Icon ms-Icon--Mail", "aria-hidden": "true", style: { marginRight: 4 } }),
                "Reach out")) : null)));
};
